import { createFileRoute } from "@tanstack/react-router";
import ServiceHubspot from "@/pages/ServiceHubspot";
import {
  buildPageHead,
  breadcrumbSchema,
  serviceSchema,
  faqPageSchema,
} from "@/lib/seo";

const faqs = [
  {
    question: "What does a HubSpot RevOps Architect do?",
    answer:
      "A HubSpot RevOps Architect designs and scales the complete revenue infrastructure across all five HubSpot hubs, Marketing, Sales, Service, Operations, and Content. That includes custom lifecycle stages, deal pipelines, Operations Hub custom-code workflows, multi-branch automation, custom property schemas, attribution tracking, and executive BI dashboards.",
  },
  {
    question:
      "Do you build Operations Hub custom-code workflows or only no-code automation?",
    answer:
      "Both. Where no-code workflows hit their limits, I engineer JavaScript custom-code actions in Operations Hub for conditional logic, data transformations, webhook orchestration, and API calls that no-code simply cannot reach.",
  },
  {
    question: "Can you migrate our data from another CRM into HubSpot?",
    answer:
      "Yes. I handle complex CRM migrations into HubSpot, mapping custom fields, historical activity, associations between deals and companies, and recreating all automated workflows to ensure zero data loss during cutover.",
  },
  {
    question: "How do you work with our internal team?",
    answer:
      "I work directly with your leadership and RevOps team as a senior systems architect. Every build includes complete architecture documentation, video SOPs, and team training so your reps and admins have total clarity.",
  },
];

export const Route = createFileRoute("/hubspot-revops-architect")({
  head: () =>
    buildPageHead({
      title: "HubSpot RevOps Architect, 5-Hub CRM Engineer | Marjohn Robillo",
      description:
        "Hire a dedicated HubSpot RevOps Architect who engineers the full 5-hub architecture with Operations Hub custom-code workflows, lifecycle stages, lead-to-revenue automation, and executive revenue dashboards.",
      path: "/hubspot-revops-architect",
      keywords:
        "HubSpot RevOps architect, HubSpot CRM architect, HubSpot Operations Hub custom code, HubSpot automation, HubSpot consultant, enterprise HubSpot workflows, 5-hub architecture, CRM systems engineer, HubSpot migration",
      schema: [
        serviceSchema({
          name: "HubSpot RevOps Architecture & Revenue Operations",
          description:
            "Custom HubSpot 5-hub lifecycle architecture, Operations Hub custom-code workflow automation, and executive revenue intelligence for scaling B2B businesses.",
          path: "/hubspot-revops-architect",
          serviceType: [
            "HubSpot 5-Hub CRM Architecture",
            "Operations Hub Custom-Code Workflows",
            "Enterprise Workflow Automation",
            "Pipeline & Deal Stage Engineering",
            "Executive Revenue Intelligence",
          ],
        }),
        breadcrumbSchema([
          { name: "Home", path: "" },
          {
            name: "HubSpot RevOps Architect",
            path: "/hubspot-revops-architect",
          },
        ]),
        faqPageSchema(faqs),
      ],
    }),
  component: ServiceHubspot,
});
